export const trackSamplePageLoadedInPlugin = (
    isDAWPlugin: boolean,
    milestoneAlreadySet: boolean,
    perform: (flag: string, shouldUpdateSession?: boolean | undefined) => void,
) => {
    if (isDAWPlugin && !milestoneAlreadySet) {
        perform('SamplesPageLoadedInPlugin', true);
    }
};
